export default __webpack_public_path__ + "static/media/flourishing_outline_petal.6c9bbf3d.svg";